import { useRouter } from 'next/router';

const IsStadium = () => {
  const router = useRouter();

  return router.pathname === '/raiders';
};

export default IsStadium;
